import {ModelMapper} from "../services/model-mapper";
import {Pack, PackModel} from "./pack.model";
import {Prompt, PromptModel} from "./prompt.model";

export type PackItem = Prompt | Pack
export type PackItemModel = PromptModel | PackModel

export const packItemMapper = new ModelMapper((src: PackItem) => {
  switch (src.type) {
    case 'pack':
      return new PackModel(src as Pack)
    case 'prompt':
      return new PromptModel(src as Prompt)
    default:
      throw new Error(`Unknown pack item type: ${src.type}`)
  }
})
